<template>
	<el-table
			v-if=" !loading && propsData && show && tabData.length > 0"
			height="100%"
			:data="tabData"
			style="width: 100%">
		<el-table-column
				fixed
				label="数据类型"
				width="220"
		>

			<el-table-column
					prop="date"
					label="时间"
					width="220">
			</el-table-column>

		</el-table-column>

		<el-table-column
				fixed
				prop="total"
				label="总电量"
				width="200">
		</el-table-column>

		<el-table-column
				v-for="(item, index) in tab" :key="index"
				:label="item.title"
				width="220">

			<el-table-column
					v-for="(sub, i) in item.children" :key="i"
					:prop="sub.prop"
					:label="sub.title"
					width="220">
			</el-table-column>

		</el-table-column>

	</el-table>
	<div v-else class="row-center tip">
		<img v-if="loading" src="../../../assets/img/loading.png" class="loading">
		<img v-else src="../../../assets/img/not_found_data.png" alt="">
	</div>
</template>

<script>
	import {POWER_ANALYSIS_BY_LOOP} from "../../../api/power";
	import {monthDays} from "../../../util/DateUtil";
	import {floatFormat} from "../../../util/MathUtil";
	import exportExcel from "../../../util/excel";

	export default {
		name: "PowerRange",
		props: {
			loops: Array,
			range: String,
			date: Date
		},
		data() {
			return {
				loading: false,
				show: true,
				tabData: [],
				tab: [
					{
						title: "尖",
						children: [
							{
								title: "尖电量",
								prop: "sum_tip"
							},
							{
								title: "尖占比",
								prop: "percentage_tip"
							}
						]
					},
					{
						title: "峰",
						children: [
							{
								title: "峰电量",
								prop: "sum_peak"
							},
							{
								title: "峰占比",
								prop: "percentage_peak"
							}
						]
					},
					{
						title: "平",
						children: [
							{
								title: "平电量",
								prop: "sum_level"
							},
							{
								title: "平占比",
								prop: "percentage_level"
							}
						]
					},
					{
						title: "谷",
						children: [
							{
								title: "谷电量",
								prop: "sum_valley"
							},
							{
								title: "谷占比",
								prop: "percentage_valley"
							}
						]
					},
				]
			}
		},
		mounted() {
			this.requestData()
		},
		methods: {
			async requestData() {

				this.tabData = []
				if (this.loops.length <= 0) {
					return
				}

				this.loading = true
				let res = await Promise.all(this.loops.map(l => POWER_ANALYSIS_BY_LOOP(this.date, this.range, l.loopId)))
				let list = []

				try {
					this.loops.forEach((l, i) => {

						let resData = res[i].data.data.result
						if (resData) {
							let year = 'year_' + this.date.getFullYear()
							let month = 'month_' + (this.date.getMonth() + 1)

							// 总数居
							resData.date = '总'
							list.push(resData)

							if (this.range === 'month') {
								let monthData = resData[year][month]

								for (let j = 1; j <= monthDays(this.date); j++) {
									let dayData = monthData['day_' + j]
									if (dayData) {
										dayData.total = dayData.daySum
										dayData.date = j + '日'
										list.push(dayData)
									}
								}

							} else {
								// 年的
								let yearData = resData[year]
								for (let j = 1; j <= 12; j++) {
									let monthData = yearData['month_' + j]
									if (monthData) {
										monthData.total = monthData.monthSum
										monthData.date = j + '月'
										list.push(monthData)
									}
								}
							}

						} else {

						}
					})
					// console.log(list);

					list.forEach(e => {
						// 处理
						for (let k in e) {
							if (e.hasOwnProperty(k)) {
								if (k === 'date') {
									continue
								}
								if (e[k] === "NaN") {
									e[k] = '--';
									continue;
								}
								if (k.startsWith("percentage")) {
									e[k] = floatFormat(e[k] * 100, 2) + ' %'
								} else {
									e[k] = floatFormat(e[k], 2) + ' kWh'
								}
							}
						}

						["percentage_level",
							"percentage_peak",
							"percentage_tip",
							"percentage_valley",
							"sum_level",
							"sum_peak",
							"sum_tip",
							"sum_valley",
							"total"].forEach(k => {
							if(!e[k]){
								e[k] = '--'
							}
						})
					})
				} catch (e) {
					console.log(e)
					list = []
				}


				this.show = false
				this.tabData = list
				this.loading = false
				this.$nextTick(() => {
					this.show = true
				})


			}
		},
		computed: {
			diagramStatus(){
				return this.$store.state.project.diagramStatus
			},
			propsData() {
				return [
					this.range,
					this.date,
					this.loops
				]
			}
		},
		watch: {
			diagramStatus(n){
				if(this.$route.params.name === 'Extremum' && this.$route.params.tag === 'Range' ){
					if(n.type === 'excel' && this.tabData.length > 0){

						let data = [
							['数据类型', '总电量(KWH)'],
							['时间', null],
						]

						let merges = [
							{s: {r: 0, c: 1}, e: {r: 1, c: 1}},
						]

						this.tab.forEach((d, i) => {
							data[0].push(d.title, null)
							data[1].push(d.children[0].title, d.children[1].title)

							merges.push({s: {r: 0, c: 2 + i * 2}, e: {r: 0, c: 3 + i * 2}})
						})


						this.tabData.forEach(d => {
							data.push([
								d['date'],
								d['total'],
								d['sum_tip'],
								d['percentage_tip'],
								d['sum_peak'],
								d['percentage_peak'],
								d['sum_level'],
								d['percentage_level'],
								d['sum_valley'],
								d['percentage_valley'],
							])
						})
						exportExcel(data, '尖峰平谷报表', merges)

					}else {
						this.$message.warning("无图表数据！")
					}
				}
			},
			propsData(n) {
				this.requestData()
			}
		}
	}
</script>

<style scoped lang="less">
	.tip {
		width: 100%;
		height: 100%;
		font-size: 16rem;
		color: #8c939d;
	}

	.loading {
		width: 28rem;
		height: 28rem;
		animation: loading 1s linear infinite;
	}

	@keyframes loading {
		0% {
			transform: rotate(0);
		}
		100% {
			transform: rotate(360deg);
		}
	}
</style>